import { useEffect } from 'react';
import { toast } from 'sonner';
import { useErrorBus } from '@/errors/useErrorBus';

const TOAST_DURATION = 4000;

export function ToastContainer() {
  const { subscribe } = useErrorBus();

  useEffect(() => {
    return subscribe(error => {
      toast.error(error.message, {
        duration: TOAST_DURATION,
      });
    });
  }, [subscribe]);

  return null; // Sonner handles the UI via Toaster in App.jsx
}

export default ToastContainer;
